import classnames from 'classnames';
import * as React from 'react';
import { useLocation } from 'react-router';
import { isBranch } from '../../../../utils/locationUtils';
import { TopBarNavigation } from '../TopBarNavigation';
import style from './MobileHeaderLinksMenu.scss';

export const MobileHeaderLinksMenu = ({ isMobileMenuOpen, isPreview }) => {
  const location = useLocation();

  return (
    <div
      className={classnames({
        [style.mobileHeaderLinksMenu]: true,
        [style.show]: isMobileMenuOpen,
        [style.withNotificationBar]: isBranch(location) || isPreview,
      })}
    >
      <TopBarNavigation />
    </div>
  );
};
